<div class="content">

    <div class="text-left mt-5">

        <h3>Change Job Settings</h3> <br>
    
        <p>You can process automatically ("default”) with particular process_type and
            <b>file_management_copy_preference</b> for all files or you can decide at the time of
            batch job submission("ask_me_every_time”).
        </p>
    
      
        <!-- <div class="table-responsive">
            <table class="table table-primary table-bordered">
                <tbody>
                  <tr>
                    <td><h5>process_type</h5></td>
        
                    <td colspan="4">
        
                       <h5>string</h5><br>
        
                        <b>Items Enum:</b>
                        <p>"size" "quality" "1080p" "4k" "default"</p><br>
                
                        <b>List of allowed process type:</b>
                        <p>
                            Video_optimizer supports [size, quality]. Video_upscaler
                            supports[1080p, 4k, default]
                        </p>
        
                    </td>
                  </tr>
                </tbody>
            </table>
        </div><br> -->
    
    
        <!-- <div class="table-responsive">
    
            <table class="table table-primary table-bordered">
                <tbody>
                  <tr>
                    <td><h5>file_management_copy_preference</h5></td>
        
                    <td colspan="4">
        
                       <h5>string</h5><br>
        
                        <b>Items Enum:</b>
                        <p>"replace_original_file" "manual_copy" "create_copy"</p><br>
                
                        <b>List of allowed file management:</b>
                        <p>
                            copy preference
                        </p>
        
                    </td>
                  </tr>
                </tbody>
            </table>
    
        </div><br> -->
    
      <!-- <b>Note:</b><br><br>

      <p>We can set Ask me everytime flag true by calling /v1/customer/update. <a routerLink="/jobSettings" target="_blank">Please refer customer update API</a></p>
      
      <p>By default ask_me_every_time is set to FALSE,</p>

      <ul>

        <li>
          <p><i class="fa fa-angle-double-right" aria-hidden="true"></i>
            If optimizer_process_settings=>ask_me_every_time is TRUE
            Then process_type is  is mandatory for Optimiser job
          </p>
        </li>

        <li>
          <p><i class="fa fa-angle-double-right" aria-hidden="true"></i>
            If upscaler_process_settings=>ask_me_every_time is TRUE
            Then process_type is mandatory for Upscaler job 
          </p>
        </li>

        <li>
          <p><i class="fa fa-angle-double-right" aria-hidden="true"></i>
            If If optimizer_file_management_properties=> ask_me_every_time is TRUE
            Then file_copy_preference value is mandatory for Optimiser job
          </p>
        </li>

        <li>
          <p><i class="fa fa-angle-double-right" aria-hidden="true"></i>
            If upscaler_file_management_properties=> ask_me_every_time is TRUE then
            file_copy_preference value is mandatory for Upscaler job 
          </p>
        </li>

      </ul><br> -->
     
      <!-- <p>In below example, <b>ask_every_type</b> for upscaler.</p> -->
      <p>In the below example, Changing optimizer_process_settings, type to quality</p><br>
    
    
      <div class="card text-bg-dark mb-3">
        <div class="card-body">

          <div class="card-title">
            <button style="float: right;" *ngIf="copyButton" class="btn btn-outline-primary btn-sm" (click)="copyJsonToClipboard()">
              <i class="fa fa-clipboard" aria-hidden="true"></i>
            </button>
              
            <button style="float: right;" *ngIf="copiedButton"  class="btn btn-success btn-sm">
              Copied <i class="fa fa-check" aria-hidden="true"></i>
            </button>
      
           </div><br><br>
           
            <pre><code [innerHTML]="requestData" ></code></pre>
        </div>
      </div>
    
    
      <br><br><div class="card text-bg-light mb-3">
        <div class="card-body">

          <div class="panel panel-primary">
            <div class="tab-menu-heading">
              <ul class="nav nav-pills" role="tablist">
                <!-- Tab menu items -->
                <li class="nav-item" role="presentation">
                  <button class="nav-link active" id="tab1" data-bs-toggle="tab" data-bs-target="#content1"
                    type="button" role="tab" aria-controls="content1" aria-selected="true">200</button>
                </li>
              </ul>
            </div>

            <div class="panel-body tabs-menu-body mt-4">
              <div class="tab-content">
                <!-- Tab content -->
                <div class="tab-pane fade show active" id="content1" role="tabpanel" aria-labelledby="tab1">
                  <div class="card-body">
                    <pre><code [innerHTML]="responseData" ></code></pre>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    
    
    <!-- <br><p>
      In below example, we are setting File Management preference for Optimizer, process
      automatically and replace original file.
    </p>
    
    
    <div class="card text-bg-dark mb-3">
        <div class="card-body">
            <pre><code [innerHTML]="Data" ></code></pre>
        </div>
    </div><br> -->
    
    <br><br><h3>API doc link:</h3><br>


    <ul>
        <li>
          <a routerLink="/apilist/customerupdate" target="_blank"><h5><i class="fa fa-angle-double-right" aria-hidden="true"></i> Customer Update</h5></a>
        </li>
      </ul>
    
    <!-- <p><a href="http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/
        customerUpdate">http://cmw-dev-som-documentation.s3-website-us-east-1.amazonaws.com/#operation/
        customerUpdate</a></p> -->
    

    </div>

</div>

